import React from 'react';
import { FaEdit, FaTrash, FaLayerGroup, FaInfoCircle, FaCalendarAlt, FaBuilding } from 'react-icons/fa';

const formatCamelCase = (text) => {
  if (!text) return "";
  return text
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[_-]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, char => char.toUpperCase());
};

const ProjectMobileCard = ({ project, handleEdit, handleDelete, hasPermission }) => {
  let statusClass = 'pmp-status-active';
  if (project.status === 'Expired') statusClass = 'pmp-status-expired';
  if (project.status === 'Inactive') statusClass = 'pmp-status-inactive';

  return (
    <div className="project-mobile-card mb-2" key={project.id}>
      <div className="d-flex justify-content-between align-items-start mb-1">
        <h6 className="project-card-title m-0">{project.projectName}</h6>
        <span className={`pmp-status-tag ${statusClass}`}>
          {project.status}
        </span>
      </div>
      <div className="card-data-grid mt-2">
        <div className="data-item">
          <FaLayerGroup className="text-danger" />
          <span className="lbl">Type:</span>
          <span className="val">{formatCamelCase(project.projectType)}</span>
        </div>
        <div className="data-item">
          <FaInfoCircle className="text-info" />
          <span className="lbl">Status:</span>
          <span className="val">{project.status}</span>
        </div>
        <div className="data-item">
          <FaCalendarAlt className="text-success" />
          <span className="lbl">Start:</span>
          <span className="val">{project.projectStartDate}</span>
        </div>
        <div className="data-item">
          <FaCalendarAlt className="text-warning" />
          <span className="lbl">End:</span>
          <span className="val">{project.projectEndDate}</span>
        </div>
      </div>
      <hr className="compact-hr" />
      <div className="d-flex justify-content-between align-items-center">
        <div className="house-data">
          <FaBuilding className="text-info me-1" style={{ fontSize: '10px' }} />
          <span className="house-name-gold">{project.projectDirectorName}</span>
        </div>
        <div className="pmp-action-btn-group">
          {hasPermission('Projects', 'Edit') && (
            <button 
              type="button" 
              className="pmp-btn-action pmp-btn-edit" 
              onClick={() => handleEdit(project.id)}
              title="Edit Project"
            >
              <FaEdit size={14} color="#ffffff" />
            </button>
          )}
          {hasPermission('Projects', 'Delete') && (
            <button 
              type="button" 
              className="pmp-btn-action pmp-btn-delete" 
              onClick={() => handleDelete(project)}
              title="Delete Project"
            >
              <FaTrash size={14} color="#ffffff" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectMobileCard;
